/*
 * Favourites.
 *
 * Shopify has no native wishlist, so this keeps a list of product handles in
 * the visitor's own browser. It is per-device by design — it will not follow
 * someone to their phone. Swapping this for a wishlist app later means
 * replacing this file and the two snippets that call it, nothing else.
 */
(function () {
  var KEY = 'jo-favorites';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      // Private mode, or storage disabled. Behave as if nothing is saved.
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* nothing we can do; the button just won't persist */
    }
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle);
    else list.splice(i, 1);
    write(list);
    return i === -1;
  }

  function paintButton(btn) {
    var on = has(btn.getAttribute('data-jo-fav'));
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.classList.toggle('is-saved', on);
    var label = btn.querySelector('[data-jo-fav-label]');
    if (label) label.textContent = on ? 'Saved' : 'Add to Favorites';
  }

  function bind() {
    document.querySelectorAll('[data-jo-fav]').forEach(function (btn) {
      if (btn.dataset.joFavBound) return;
      btn.dataset.joFavBound = '1';
      paintButton(btn);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        toggle(btn.getAttribute('data-jo-fav'));
        paintButton(btn);
      });
    });
  }

  // Exposed so the favourites page can read the same list.
  window.JoFavorites = { read: read, has: has, toggle: toggle, refresh: bind };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})();
